// "Markér alle" and "Tilføj til IT-opgaver" for a card of rows (Konfiguration and Compliance). Gennemgang has its own, built on findings.
// A card becomes one point on the IT list (its key starts with cmp: or cfg:, so it is not tidied away like a resolved finding), and the
// rows that are ticked become the objects in it.
export const itKeyOf = (prefix, cardKey) => `${prefix}:${String(cardKey).replace(/[^A-Za-z0-9_.-]/g, '-').slice(0, 70)}`;

export function cardItProps({ prefix, areaName, card, selCard, picked, selId, setPicked, activateCard, itList }) {
  const key = itKeyOf(prefix, card.key);
  const isSel = selCard?.key === card.key;
  const rows = card.rows || [];
  const allPicked = isSel && rows.length > 0 && picked.size === rows.length;
  const targets = isSel ? (picked.size > 0 ? rows.filter((r) => picked.has(r.id)) : rows.filter((r) => r.id === selId)) : [];
  const onList = targets.length > 0 && targets.every((r) => itList.has(key, String(r.id).slice(0, 200)));
  return {
    markAll: rows.length > 1 ? {
      label: allPicked ? 'Fjern markering' : `Markér alle ${rows.length}`,
      onClick: () => { activateCard(card); setPicked(allPicked ? new Set() : new Set(rows.map((r) => r.id))); },
    } : null,
    it: {
      on: onList,
      disabled: targets.length === 0,
      label: onList ? 'På IT-opgaver' : `Tilføj ${targets.length > 1 ? `${targets.length} ` : ''}til IT-opgaver`,
      onToggle: () => {
        const ids = targets.map((r) => String(r.id).slice(0, 200));
        (onList
          ? itList.remove(key, ids)
          : itList.add({ key, title: card.title, area: areaName, tone: card.tone === 'bad' ? 'bad' : 'warn', objects: targets.map((r) => ({ id: String(r.id).slice(0, 200), name: r.title })) })
        ).catch(() => {});
      },
    },
  };
}
